<template>
  <div>
    <div :class="$style.outer" v-if="editable">
      <div class="button__tab" v-for="item in options" :key="item.value"
        :class="[item.type, value === item.value ? 'active' : '']"
        @click="$emit('input', item.value);$emit('change')"
      >
        {{ item.label }}
      </div>
    </div>
    <div v-else-if="optionsMap[value]" class="button__tab active" :class="optionsMap[value].type">
      <div>
        <div>{{ optionsMap[value].label }}</div>
        <div :class="$style.small" v-if="form">评定时间:{{ data.judge_at }}  {{ data.judgeUser ? data.judgeUser.realname : '' }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: [ String, Number ],
    form: Object,
    data: Object,
    options: {
      type: Array,
      default: () => []
    },
    editable: {
      type: Boolean,
      default: true
    },
  },
  inject: ['detail'],
  computed: {
    optionsMap () {
      let map = {}
      this.options.forEach(a => map[a.value] = a)
      return map
    }
  }
}
</script>

<style lang="scss" module>
.outer {
  display: flex;
}
.small {
  font-size: 12px;
}
</style>
<style lang="scss" scope>
$tab-colors: (
  'success': #37b64a,
  'primary': #3285fc,
  'danger': #ff0000,
);


@mixin button__tab__colors {
  @each $key, $value in $tab-colors {
    &.#{$key} {
      border-color: #{$value};
      &:hover {
        background-color: lighten($value, 35%);
        color: #{$value};
      }
      &.active {
        background-color: $value;
        color: #fff;
      }
    }
  }
}

.button__tab {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 180px;
  width: fit-content;
  padding:5px 10px;
  min-height: 54px;
  border: 1px solid #000;
  margin-right: 10px;
  border-radius: 7px;
  box-sizing: border-box;
  color: #010101;
  font-size: 15px;
  line-height: 20px;
  text-align: center;
  cursor: pointer;
  @include button__tab__colors;
}
</style>
